class MegaMenu extends HTMLElement {
  constructor() {
    super();
    this.timer = null;
    this.closeTimer = null;
    this.items = this.querySelectorAll('.megamenu__details');
    this.menus = this.querySelectorAll('.megamenu');

    this.items.forEach((item) => {
      item.addEventListener('mouseenter', this.menuOpen.bind(this));
      item.addEventListener('mouseleave', this.menuClose.bind(this));
    });
    this.menus.forEach((menu) => {
      menu.addEventListener('mouseenter', this.menuEnter.bind(this));
      menu.addEventListener('mouseleave', this.menuClose.bind(this));
    });
  }

  menuClose(event) {
    var menuItem = event.target.closest('.megamenu__details');
    var nextTarget = event.relatedTarget;

    if (!menuItem || (nextTarget && menuItem.contains(nextTarget))) {
      return;
    }

    this.timer = setTimeout(function(){
      menuItem.removeAttribute('open');
      menuItem.querySelector('summary').setAttribute('aria-expanded', false)

      if (!document.querySelector('.megamenu__details[open]')) {
        document.getElementById('shopify-section-header').classList.remove('section-filled')
      }
    }, 200);
  }

  menuEnter(event) {
    clearTimeout(this.timer);
    clearTimeout(this.closeTimer);
    document.getElementById('shopify-section-header').classList.add('section-filled')
  }

  menuOpen(event) {
    var clickedItem = event.target;
    clearTimeout(this.timer);
    clearTimeout(this.closeTimer);
    document.getElementById('shopify-section-header').classList.add('section-filled')
    clickedItem.setAttribute('open', '');
    clickedItem.querySelector('summary').setAttribute('aria-expanded', true)
    document.querySelector('.header__search details').removeAttribute('open');  

    this.items.forEach((item) => {
      if(item != clickedItem) {
        item.removeAttribute('open')
        item.querySelector('summary').setAttribute('aria-expanded', false)
      }
    })
  }
}

customElements.define('mega-menu', MegaMenu);